var exports = {
  "k": "xb99ab02a--bfffe1--container",
};

module.exports = exports;
